var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.nationalSponsor && _vm.useLabel)?_c('span',{staticClass:"flavor-text"},[_vm._v(_vm._s(_vm.simulationType.toLowerCase().includes('virtual')
			? _vm.$t('sponsoredBy')
			: _vm.$t('poweredBy')))]):_vm._e(),(_vm.nationalSponsor)?_c('img',{staticClass:"logo",attrs:{"src":_vm.nationalSponsor,"alt":"sponsor"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }